const statesWithMandSN = ["Vermont", "Utah", "West Virginia"];

export default statesWithMandSN;
